import { useThemeContext } from "hooks/useContextAll";
import React from "react";

const ThemeContainer = () => {
    const themeContext = useThemeContext();

    return (
        <li className="accessories-item">
            <button
                className={`header-btn theme-btn ${themeContext.theme === "dark" ? "active" : ""}`}
                onClick={themeContext.handleTheme}
            >
                <span>
                    <ion-icon name="sunny-outline"></ion-icon>
                </span>
                <span>
                    <ion-icon name="moon"></ion-icon>
                </span>
            </button>
        </li>
    );
};

export default ThemeContainer;
